(function () {

    "use strict";

    angular
        .module("harriApp")
        .component("tagsManagerComponent", {
            controller: TagsManagerComponentController,
            bindings: {
                brandId: '<',
                candidateId: '<',
                candidateName: '<',
                ngModel: '=',
                onChange: '&',
                onTagToggled: '&',
                inAssignMode: '<',
                showSelectAllAction: '<',
                enableStatusTagsAction: '<',
                type: '<',
                candidateTags: '<',
                isOptedOut: '<',
                isBlockedFromRehire: '<',
                tagsExpandState: '<',
                onReset: '<',
                onExpandTagSection: '&',
                groupsConditions: '<',
            },
            controllerAs: '$ctrl',
            templateUrl: '../modules/speedy_screen/components/tags-manager/tags-manager.component.html'
        });

    TagsManagerComponentController.$inject = ['ColorsHelper', 'tagsDataService', 'tagsEventsDataService', 'brandServices', 'hUser', '$filter', '$scope', '$element', '$timeout', '$modal', 'userPermissions', 'talentPoolDataService', 'TalentPoolSearchService'];

    function TagsManagerComponentController(ColorsHelper, tagsDataService, tagsEventsDataService, brandServices, hUser, $filter, $scope, $element, $timeout, $modal, userPermissions, talentPoolDataService, TalentPoolSearchService) {

        var self = this;

        const tagsComponentTypes = {
            TAGS_ADVANCED_FILTER: 'TAGS_ADVANCED_FILTER',
            TAGS_FILTER: 'TAGS_FILTER',
        }
        const tagsModes = {
            INCLUDE_ANY: 'INCLUDE_ANY',
            INCLUDE_ALL: 'INCLUDE_ALL',
        }
        const tagsConditions = {
            AND: 'AND',
            OR: 'OR',
        }
        self.tags = {};
        self.orginalTags = {};
        self.TAGS_TYPES = tagsDataService.TAGS_TYPES;
        var TAGS_LABEL_MAP = tagsDataService.TAGS_LABEL_MAP;
        let isGPLevel = hUser.isTopLevelContext();
        let isHighestParent;
        const recruitmentHubSpeedy = tagsDataService.RECRUITMENT_HUB_SPEEDY;

        self.isAssignTagDropdownOpen = {};
        self.tagFilterValues = {};

        self.searchInput = {};
        self.SHOW_LIMIT = 5;
        self.NO_LIMIT=99999;
        self.limitTo = {
            'GLOBAL': self.SHOW_LIMIT,
            'STATUS': self.SHOW_LIMIT,
            'GENERAL': self.SHOW_LIMIT,
            'LOCAL': self.SHOW_LIMIT,
            'PRIVATE': self.SHOW_LIMIT,
            'POSITION': self.SHOW_LIMIT,
        };

        self.allChildrenSelected = {
            'GLOBAL': false,
            'STATUS': false,
            'GENERAL': false,
            'LOCAL': false,
            'PRIVATE': false,
            'POSITION': false
        };

        self.onSelectAll = function (section, isChecked) {
            if (self.tags[section].length) {
                self.allChildrenSelected[section] = isChecked;
                var status = isChecked ? 'SELECTED':'UNSELECTED';
                if (isChecked){
                    for (var i = 0; i< self.tags[section].length;i++){
                        if (!self.isTagSelected(self.tags[section][i].id)) {
                            self.ngModel.push(self.tags[section][i]);
                        } else {
                            self.tags[section][i].selected = true;
                        }
                    }
                } else {
                    for (var i = 0; i < self.tags[section].length; i++) {
                        for (var j = 0; j < self.ngModel.length; j++) {
                            if (self.tags[section][i].id === self.ngModel[j].id) {
                                self.ngModel.splice(j, 1);
                            }
                        }
                    }
                }

                self.candidateTags = tagsDataService.prepareCandidateTagsViewData(self.ngModel);

                if (self.type !== tagsComponentTypes.TAGS_FILTER) {
                    if (self.onChange) {
                        self.onChange({
                            'tags': self.ngModel
                        });
                    }
                }

                if (self.onTagToggled) {
                    self.onTagToggled({
                        'data': {
                            tags: [self.tags[section]],
                            status: status
                        }
                    });
                }
            }
        };

        self.toggleShowMore = function(type){
            self.limitTo[type] = self.limitTo[type] === self.NO_LIMIT? self.SHOW_LIMIT: self.NO_LIMIT;
        };

        var prepareOriginalTags = function (tagsGroup) {
            var originalTags = {};
            var tagGroupIds = _.pluck(self.tagGroups, 'id');

            for (var i = 0; i < tagGroupIds.length; i++) {
                var tagId = tagGroupIds[i];

                originalTags[tagId] = tagsGroup[tagId] || [];
            }

            return originalTags;
        };

        self.runClickOutsideTagFilter = function (tagGroupId) {
            $timeout(function () {
                $element.find('.talent-pool-tags .' + tagGroupId + ' .filter-wrapper').on('hide.bs.dropdown', function (event) {
                    clearSearchInput(tagGroupId);
                    $scope.$evalAsync();
                });
            }, 1);
        };

        var prepareTagGroups = function (tagGroups) {
            var tagGroupsArr = [];

            for (var i = 0; i < tagGroups.length; i++) {
                var tagGroup = tagGroups[i];
                tagGroup.shown = self.tagsExpandState[tagGroup.id];
                tagGroupsArr.push(tagGroup);
            }

            return tagGroupsArr;
        };

        self.$onInit = () => {
            init();
        };

        const init = async () => {
            const policyParser = await userPermissions.getBrandPolicy(self.brandId);
            const canManagePrivateTags = policyParser.has(userPermissions.PERMISSIONS.MANAGE_PRIVATE_TAGS);
            let tagGroupOptions = [
                {
                    id: 'STATUS',
                    label: TAGS_LABEL_MAP.STATUS.label,
                    icon: 'fa-solid fa fa-star',
                    placeholder: TAGS_LABEL_MAP.STATUS.placeholder,
                    checkVisibility: function () {
                        return (self.orginalTags.STATUS && !!self.orginalTags.STATUS.length);
                    },
                    shown:true,
                    mode: tagsModes.INCLUDE_ANY
                },
                {
                    id: 'POSITION',
                    label: TAGS_LABEL_MAP.POSITION.label,
                    icon: 'fa fa-tags fa-rotate-90',
                    placeholder: TAGS_LABEL_MAP.POSITION.placeholder,
                    checkVisibility: function () {
                        return (self.orginalTags.POSITION && !!self.orginalTags.POSITION.length);
                    },
                    shown:true,
                    mode: tagsModes.INCLUDE_ANY
                },
                {
                    id: 'GENERAL',
                    label: TAGS_LABEL_MAP.GENERAL.label,
                    icon: 'fa fa-tags fa-rotate-90',
                    placeholder: TAGS_LABEL_MAP.GENERAL.placeholder,
                    checkVisibility: function () {
                        return (self.orginalTags.GENERAL && !!self.orginalTags.GENERAL.length);
                    },
                    shown: false,
                    mode: tagsModes.INCLUDE_ANY
                },
                {
                    id: 'GLOBAL',
                    label: TAGS_LABEL_MAP.GLOBAL.label,
                    icon: 'fa fa-tags fa-rotate-90',
                    placeholder: TAGS_LABEL_MAP.GLOBAL.placeholder,
                    checkVisibility: function () {
                        return (!!self.orginalTags?.GLOBAL?.length) || self.isGTPServiceEnabled;
                    },
                    shown: false,
                    mode: tagsModes.INCLUDE_ANY
                },
                {
                    id: 'PRIVATE',
                    label: TAGS_LABEL_MAP.PRIVATE.label,
                    icon: 'fa fa-tags fa-rotate-90',
                    placeholder: TAGS_LABEL_MAP.PRIVATE.placeholder,
                    checkVisibility: function () {
                        return (!!self.orginalTags?.PRIVATE?.length || (self.type !== recruitmentHubSpeedy && isGPLevel)) && canManagePrivateTags;
                    },
                    shown: false,
                    mode: tagsModes.INCLUDE_ANY
                },
                {
                    id: 'LOCAL',
                    label: TAGS_LABEL_MAP.LOCAL.label,
                    icon: 'fa fa-tags fa-rotate-90',
                    placeholder: TAGS_LABEL_MAP.LOCAL.placeholder,
                    checkVisibility: function () {
                        return !!self.orginalTags?.LOCAL?.length || self.type === recruitmentHubSpeedy || !isGPLevel;
                    },
                    shown: false,
                    mode: tagsModes.INCLUDE_ANY
                },
            ];

            self.isLoading = true;
            self.ngModel = self.ngModel || [];
            self.tagGroups = self.tagsExpandState ? prepareTagGroups(tagGroupOptions) : tagGroupOptions;
            isHighestParent = hUser.isHighestParent(self.brandId);

            var promises = {
                'tagsGroup': tagsDataService.getByBrandId(self.brandId, true),
                'isGTPServiceEnabled': brandServices.check(brandServices.SERVICES.GLOBAL_TALENT_POOL, self.brandId),
                'canManageGlobalTags': tagsDataService.canManageGlobalTags(self.brandId),
                'brandProfile': ProfileAPI.getBrandProfile(self.brandId)
            };

            $q.all(promises)
                .then(function (res) {
                    if (res.tagsGroup) {
                        ['GLOBAL', 'STATUS'].forEach((key) => {
                            if (res.tagsGroup[key]) {
                                res.tagsGroup[key].sort((a, b) => a.sort_order - b.sort_order);
                            }
                        });
                    }
                    self.canManageGlobalTags = res.canManageGlobalTags;
                    self.tags = res.tagsGroup;
                    self.brandProfile = res.brandProfile;
                    self.orginalTags = prepareOriginalTags(res.tagsGroup);
                    self.canManageLocalTags = !(res.isGTPServiceEnabled && isHighestParent);
                    self.isGTPServiceEnabled = res.isGTPServiceEnabled;

                    const brandName = self.brandProfile.external_business_name || self.brandProfile.name;
                    const optedOutTooltip = `${self.candidateName} ${$filter('translate')('cannot be added tags, because they opted out of')} ${brandName}’s ${$filter('translate')('Talent Pool')}`;
                    const blockedFromRehireTooltip = $filter('translate')('This user is blocked from rehire');

                    self.disableAddTagTooltip = self.isOptedOut ? optedOutTooltip : (self.isBlockedFromRehire ? blockedFromRehireTooltip : '');
                })
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.isLoading = false;
                    $scope.$evalAsync();
                });
            runClickOutsideAssignTagModalListener();
        };

        self.$onChanges = function (changesObj) {
            if (!changesObj.onReset?.isFirstChange()) {
                self.candidateTags = {};
            }

            if(changesObj.candidateTags?.currentValue && self.type === tagsComponentTypes.TAGS_ADVANCED_FILTER) {
                let candidateTags = changesObj.candidateTags.currentValue;
                for (let i in candidateTags) {
                    let groupTags = self.tags[i];
                    let selectedFilterTags = candidateTags[i];
                    let availableTags = [];
                    for (let j in selectedFilterTags) {
                        if (groupTags?.length && groupTags.filter(tag => tag.id === selectedFilterTags[j].id).length > 0) {
                            availableTags.push(selectedFilterTags[j]);
                        } else {
                            self.ngModel.splice(self.ngModel.findIndex(tag => tag.id === selectedFilterTags[j].id), 1);
                        }
                    }
                    candidateTags[i] = availableTags;
                }
                self.candidateTags = candidateTags;
                for (let i in self.groupsConditions) {
                    let group = self.tagGroups.find(group => group.id === self.groupsConditions[i].mode);
                    if (group) {
                        group.mode = self.groupsConditions[i].condition === tagsConditions.OR ? tagsModes.INCLUDE_ANY : tagsModes.INCLUDE_ALL;
                    }
                }
                let searchTags = self.getSelectedAdvancedFilterTags(self.ngModel);
                if (searchTags.length) {
                    TalentPoolSearchService.setAdvancedFilterTags(searchTags);
                } else {
                    TalentPoolSearchService.removeFilter('brand_tags_filter');
                }
            }
        }

        var canManageTags = function () {
            return self.canManageGlobalTags || self.canManageLocalTags;
        };

        self.filterTags = function () {
            if (Object.keys(self.searchInput).length) {
                for (var i in self.searchInput) {
                    var searchInput = self.searchInput[i];
                    var searchText = searchInput.toLowerCase();
                    for (var group in self.tags) {
                        self.tags[group] = self.orginalTags[group].filter(function (tag) {
                            return tag.name.toLowerCase().indexOf(searchText) > -1;
                        });
                    }

                }
            } else if (self.searchText?.length) {
                const searchResults = {};

                Object.entries(self.tagGroups).forEach(([groupId, tagGroup]) => {
                    const groupResults = self.orginalTags[tagGroup.id]?.filter(tag => tag.name.toLowerCase().includes(self.searchText.toLowerCase())) || [];

                    if (groupResults.length > 0) {
                        searchResults[tagGroup.label.toUpperCase()] = groupResults;
                    }
                });

                self.tags = searchResults;
            } else {
                self.tags = Object.assign({}, self.orginalTags);
            }
        };

        self.filterTagGroup = function (groupId) {
            if (self.searchInput[groupId]) {
                var searchText = self.searchInput[groupId].toLowerCase();
                self.tags[groupId] = self.orginalTags[groupId].filter(function(tag) {
                    return tag.name.toLowerCase().indexOf(searchText) > -1;
                });
            } else {
                self.tags[groupId] = angular.copy(self.orginalTags[groupId]);
            }
        };

        self.selectTag = function (tag) {
            var status;
            if(!self.isTagSelected(tag.id)){
                self.ngModel.push(tag);
                status = "SELECTED";
            }
            else{
                for( var i = 0; i<self.ngModel.length; i++){
                    if ( tag.id === self.ngModel[i].id) {
                        self.ngModel.splice(i, 1);
                    }
                }
                status = "UNSELECTED";
            }

            var tagMode = tag.is_private ? 'PRIVATE' : tag.mode;
            if (tagMode) {
                var selectedTags = [];
                for (var j = 0; j < self.tags[tagMode].length; j++) {
                    if (self.isTagSelected(self.tags[tagMode][j].id)) {
                        selectedTags.push(self.tags[tagMode][j]);
                    }
                }
                self.allChildrenSelected[tagMode] = selectedTags.length === self.tags[tagMode].length;
            }

            self.candidateTags = tagsDataService.prepareCandidateTagsViewData(self.ngModel);

            if (self.type !== tagsComponentTypes.TAGS_FILTER && self.type !== tagsComponentTypes.TAGS_ADVANCED_FILTER) {
                if (self.onChange) {
                    self.onChange({
                        'tags': self.ngModel
                    });
                }
            } else if (self.type === tagsComponentTypes.TAGS_ADVANCED_FILTER) {
                if (self.onChange) {
                    self.onChange({
                        'tags': self.getSelectedAdvancedFilterTags(self.ngModel)
                    });
                }
            }

            if (self.onTagToggled) {
                self.onTagToggled({
                    'data': {
                        tags: [tag],
                        status: status
                    }
                });
            }

            $scope.$evalAsync();
        };

        self.applyTags = function (tagGroupId) {
            self.tagFilterValues[tagGroupId] = getFilterValue(tagGroupId);
            if (self.onChange) {
                self.onChange({
                    'tags': self.ngModel
                });
            }
        };

        var getFilterValue = function (tagGroupId) {
            var selectedTags = [];

            for (var i = 0; i < self.orginalTags[tagGroupId].length; i++) {
                if (self.isTagSelected(self.orginalTags[tagGroupId][i].id)) {
                    selectedTags.push(self.orginalTags[tagGroupId][i].name);
                }
            }

            if (selectedTags.length === 1) {
                return selectedTags[0];
            } else if (selectedTags.length > 1) {
                return selectedTags.length + ' ' + $filter('translate')('Selected');
            }
        };

        self.isTagSelected = function(id){
            var isSelected = self.ngModel.filter(function(tag){
                return tag.id === id;
            });
            return isSelected.length === 1;
        };

        self.getTagsCount = function(){
            var count=0;
            for (var group in self.tags) {
                count += self.tags[group].length;
            }
            return count;
        };

        self.showAddEditTagModal = function ($event, tag) {
            if (!canManageTags()) {
                console.warn("can't manage tags");
                return;
            }

            var data = {
                brand_id: self.brandId,
                type: self.type
            };
            if (tag) {
                $event.stopPropagation();
                data['tag'] = Object.assign({}, tag);
            }
            tagsDataService.showAddModal(data, function(data){});
        };

        var onAfterCreateHandler = function(brandId, tag, res){
            var tagGroup = tagsDataService.getTagGroup(res);
            var isExists = self.orginalTags[tagGroup].filter(function(item){
                return item.id === res.id;
            });
            if(isExists.length === 0){
                self.orginalTags[tagGroup].push(res);
            }
            self.filterTags();
        };

        var onAfterDeleteHandler = function (brandId, tagId, res) {
            for (var tagGroup in self.orginalTags) {
                for (var i in self.orginalTags[tagGroup]) {
                    if (self.orginalTags[tagGroup][i].id === tagId) {
                        self.orginalTags[tagGroup].splice(i, 1);
                        break;
                    }
                }
            }
            self.filterTags();
        };

        var clearSearchInput = function (tagGroupId) {
            self.searchInput[tagGroupId] = '';
            self.filterTagGroup(tagGroupId);
        };

        self.toggleAssignTagDropdown = function (tagGroupId) {
            clearSearchInput(tagGroupId);
            var isDropdownOpen = angular.copy(self.isAssignTagDropdownOpen[tagGroupId]);
            self.isAssignTagDropdownOpen = {};
            self.isAssignTagDropdownOpen[tagGroupId] = !isDropdownOpen;
        };

        var runClickOutsideAssignTagModalListener = function () {
            $(window).on("click.add-tag-dropdown", function (event) {
                if (
                    $(event.target).parents('.add-tag-dropdown').length === 0
                ) {
                    self.isAssignTagDropdownOpen = {};
                    $scope.$evalAsync();
                }
            });
        };

        var onAfterUpdateHandler = function(brandId, tag, res){
            var tagGroup = tagsDataService.getTagGroup(res);
            for( var i=0; i<self.orginalTags[tagGroup].length; i++){
                if(self.orginalTags[tagGroup][i].id === res.id){
                    self.orginalTags[tagGroup][i] = res;
                }
            }
            self.filterTags();
        };

        var isAllChildrenSelected = function (tagGroupId) {
            var selectedTags = [];

            for (var j = 0; j < self.tags[tagGroupId].length; j++) {
                if (self.isTagSelected(self.tags[tagGroupId][j].id)) {
                    selectedTags.push(self.tags[tagGroupId][j]);
                }
            }

            return selectedTags.length === self.tags[tagGroupId].length;
        };

        var onTagsFilterUpdatedHandler = function () {
            for (var tagGroupId in self.orginalTags) {
                if (self.orginalTags[tagGroupId].length) {
                    self.tagFilterValues[tagGroupId] = getFilterValue(tagGroupId);
                    self.allChildrenSelected[tagGroupId] = isAllChildrenSelected(tagGroupId);
                }
            }
        };

        self.toggleTagGroup = function (tagGroupId) {
            var tagGroup = self.tagGroups.find(function (group) {
                return tagGroupId === group.id;
            });

            tagGroup.shown = !tagGroup.shown;
            self.onExpandTagSection({'tag_group': {id: tagGroup.id, shown: tagGroup.shown}});
        };

        var onAfterCreateRef = tagsEventsDataService.onAfterCreate(onAfterCreateHandler);
        var onAfterUpdateRef = tagsEventsDataService.onAfterUpdate(onAfterUpdateHandler);
        var onAfterDeleteRef = tagsEventsDataService.onAfterDelete(onAfterDeleteHandler);
        var onTagsFilterUpdatedRef = tagsEventsDataService.onTagsFilterUpdated(onTagsFilterUpdatedHandler);

        self.openPositionTagFeedbackModal = function (tag) {
            $modal({
                controller: 'positionTagsFeedbackModal',
                templateUrl: '../modules/speedy_screen/modals/position-tags-feedback/position-tags-feedback.modal.html',
                show: true,
                resolve: {
                    modalData: function () {
                        return {
                            brandId: self.brandId,
                            candidateId: self.candidateId,
                            tagId: tag.id
                        };
                    }
                }
            });
        };

        self.changeTagMode = function (tagGroup, mode) {
            tagGroup.mode = mode;
            if (self.onChange) {
                self.onChange({
                    'tags': self.getSelectedAdvancedFilterTags(self.ngModel)
                });
            }
        }

        self.getSelectedAdvancedFilterTags = (tagsSelected) => {
            const selectedTagsByGroup = {};

            for (const tag of tagsSelected) {
                const tagMode = tag.is_private ? 'PRIVATE' : tag.mode;

                if (!selectedTagsByGroup[tagMode]) {
                    selectedTagsByGroup[tagMode] = [];
                }
                selectedTagsByGroup[tagMode].push(tag.id);
            }

            const advancedFilterModes = [];

            Object.keys(selectedTagsByGroup).forEach((tagMode) => {
                const filterCondition = self.tagGroups.find((group) => group.id === tagMode).mode === tagsModes.INCLUDE_ALL ? tagsConditions.AND : tagsConditions.OR;
                advancedFilterModes.push({
                    condition: filterCondition,
                    mode: tagMode,
                    brand_tag_ids: selectedTagsByGroup[tagMode]
                });
            });

            return advancedFilterModes;
        };

        self.searchTags = () => {
            let hasSearchResults = false;

            if (!self.searchText) {
                self.tags = self.orginalTags;
                return;
            }

            const searchResults = {};
            Object.entries(self.tagGroups).forEach(([groupId, tagGroup]) => {
                const groupResults = self.orginalTags[tagGroup.id]?.filter(tag => tag.name.toLowerCase().includes(self.searchText.toLowerCase())) || [];

                if (groupResults.length > 0) {
                    searchResults[tagGroup.label.toUpperCase()] = groupResults;
                    hasSearchResults = true;
                }
            });

            self.tags = searchResults;
            self.hasSearchResults = hasSearchResults;
        };

        self.closeSearch = () => {
            self.searchText = '';
            self.tags = self.orginalTags;
        };

        const getTagById = (tagId, originalTags) => {
            for (const category in originalTags) {
                if (originalTags.hasOwnProperty(category)) {
                    for (const tag of originalTags[category]) {
                        if (tag.id === tagId) {
                            return tag;
                        }
                    }
                }
            }
        }

        talentPoolDataService.on("selected-tags-updated-event", (tag) => {
            const tagInfo = getTagById(tag.id, self.orginalTags);
            self.selectTag(tagInfo);
        });

        self.$onDestroy = function () {
            tagsEventsDataService.off(onAfterUpdateRef);
            tagsEventsDataService.off(onAfterDeleteRef);
            tagsEventsDataService.off(onAfterCreateRef);
            tagsEventsDataService.off(onTagsFilterUpdatedRef);
            $(window).off('click.add-tag-dropdown');
        };
    }
})();
